module.exports = __webpack_public_path__ + "static/media/CamelRidgeThroneEXTA0024_design_clean_v003.b552efa0.webp";